<template>
  <base-section
    id="bspa"
  >
    <base-section-heading
      title="Best Student Presentation Award"
    />
    <v-container>
      <base-section-heading
      divider=null
      >
      Ph.D. Students presenting a regular paper at ETS'23 concour to the best student presentation award. It is assigned depending on the presentation quality and audience feedback. The winner is announced at ETS'24 opening.
      </base-section-heading>
      <br>
      <v-row>
        <base-avatar-card
          title="Awards Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(award, i) in awards"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="award"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in studentsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < studentsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Bspa',

    data: () => ({
      isMobile: false,
      studentsfooter: [
        {
          name: 'Student Activities at ETS23',
          url: 'student-activities-23',
        },
        {
          name: 'Best Student Presentation Award',
          url: 'bspa',
        },
        {
          name: 'PhD Forum',
          url: 'student-phd-forum',
        },
        {
          name: 'McCluskey Award',
          url: 'mccluskey',
        },
        {
          name: 'Test Spring School',
          url: 'tss',
        },
        {
          name: 'Student Activities at ETS22',
          url: 'student-activities-22',
        },
      ],
      awards: [
        {
          title: 'Maria Michael',
          src: require('@/images/committees/mariamichael.jpeg'),
          text: 'University of Cyprus, CY',
        },
        {
          title: 'Maksim Jenihhin',
          src: require('@/images/committees/maksim.jpeg'),
          text: 'Taltech, EE',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
